import { useQuery } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_TEAM_ID,
  diamQueryKeys,
  getMyTeamRoles,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useMyTeamRoles() {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  return useQuery({
    queryKey: diamQueryKeys.myTeamRoles(DIAM_TEAM_ID),
    queryFn: async () => {
      const idToken = await getIdToken();
      return getMyTeamRoles(apiUrl, idToken);
    },
    enabled: isSignedIn,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
